import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import {JwtParserService} from '../../shared/services/jwt-parser.service';
import {AuthGuard} from '../../shared/services/auth.guard';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApiInterceptor} from '../../shared/services/interceptor/api.interceptor';
import {ModalService} from '../../shared/services/modal.service';
import {SharedModule} from '../../shared/shared.module';
import {ChangePlanSummaryComponent} from './change-plan-summary/change-plan-summary.component';
import {ChangePlanRoutingModule} from './change-plan-routing.module';
import {ChangePlanComponent} from './change-plan/change-plan.component';
import {AnnualPlanComponent} from './annual-plan/annual-plan.component';
import {MonthlyPlanComponent} from './monthly-plan/monthly-plan.component';
import {UpdatePlanComponent} from './update-plan/update-plan.component';
import {PaymentModalComponent} from './payment-modal/payment-modal.component';

@NgModule({
    declarations: [
        ChangePlanSummaryComponent,
        ChangePlanComponent,
        AnnualPlanComponent,
        MonthlyPlanComponent,
        UpdatePlanComponent,
        PaymentModalComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        SharedModule,
        ChangePlanRoutingModule,
    ],
    exports: [],
    providers: [JwtParserService, AuthGuard, {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiInterceptor,
        multi: true
    },
        ModalService, BsModalRef],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ChangePlanModule {
}
